import { navigateTo, useRuntimeConfig } from '#imports'
import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router'

import type { Market } from '@backmarket/http-api'

import { PAGE_NAME_BY_PLP_UUID } from '~/scopes/cms/service/content-service.config'

import { ROUTES as PRODUCT_LIST_ROUTES } from './route-names'

export default ({ market }: { market: Market }): RouteRecordRaw[] => {
  const {
    public: { FF_NEW_SELLER_PAGE },
  } = useRuntimeConfig()

  const availableUniverseUUID = PAGE_NAME_BY_PLP_UUID[market.countryCode]
  const universeRegex = availableUniverseUUID
    ? Object.keys(availableUniverseUUID).join('|')
    : '!?'

  return [
    {
      path: 'search',
      name: PRODUCT_LIST_ROUTES.SEARCH_RESULTS,
      meta: {
        owners: ['bot-squad-search-and-recommendation-front'],
      },
      component: () => import('./pages/SearchResultPage/SearchResultPage.vue'),
    },
    {
      path: 's/:merchantName/:uuid',
      name: PRODUCT_LIST_ROUTES.SELLER_PRODUCT_LIST,
      meta: {
        owners: ['bot-squad-search-and-recommendation-front'],
        cache: 'public, max-age=300',
      },
      component: () =>
        FF_NEW_SELLER_PAGE
          ? import('./pages/SellerPage/SellerPage.vue')
          : import('./pages/SellerProductListPage/SellerProductListPage.vue'),
    },
    {
      path: 'l/:slugV2/:uuid',
      name: PRODUCT_LIST_ROUTES.PRODUCT_LIST,
      meta: {
        owners: ['bot-squad-search-and-recommendation-front'],
        middleware: (to: RouteLocationNormalized) => {
          if (
            Array.isArray(to.params.uuid) || !availableUniverseUUID
              ? false
              : to.params.uuid in availableUniverseUUID
          ) {
            const universePage: RouteLocationNormalized = {
              ...to,
              name: PRODUCT_LIST_ROUTES.UNIVERSE,
            }

            return navigateTo(universePage)
          }

          return undefined
        },
        cache: 'public, max-age=90000',
      },
      component: () => import('./pages/ProductListPage/ProductListPage.vue'),
    },
    {
      name: PRODUCT_LIST_ROUTES.UNIVERSE,
      component: () => import('../cms/Landing.vue'),
      path: `l/:slugV2/:uuid(${universeRegex})`,
      meta: {
        owners: ['bot-squad-search-and-recommendation-front'],
        cache: 'public, max-age=90000',
      },
    },
  ]
}
